import { BookSectionTypeActions } from './../ActionTypes';

export const setAllBookSectionTypes = (bookSectionTypes) => ({
    type: BookSectionTypeActions.SetAll,
    bookSectionTypes
});
